<template>
  <div>
    <page-title>Banner Report</page-title>

    <loading v-if="loading" />

    <div v-else>
      <section-block>
        <template slot="header">
          Filter by dates
        </template>

        <template slot="actions">
          <base-button :primary="true">
            Export
          </base-button>
        </template>

        <base-empty v-if="!results || results.length < 1">
          <p>Search for banner statistics using the date filter above</p>
        </base-empty>
      </section-block>
    </div>
  </div>
</template>
<script>
import { mapGetters, mapState } from "vuex";
import VuetablePagination from "vuetable-2/src/components/VuetablePagination";
import Pagination from "@/components/pagination";
import BannerActions from "@/modules/banner/components/BannerActions";
import BaseEmpty from '@/components/elements/BaseEmpty.vue';
export default {
  name: "BannerAdminIndex",

  components: {
    BannerActions,
    Pagination,
    VuetablePagination,
    BaseEmpty
  },
  data() {
    return {
      loading: true,
      searchQuery: null,
      table: {
        fields: [
          {
            name: "title",
            titleClass: "u-ta-left",
            title: "Banner Title",
            width: "30%",
          },
          {
            name: "description",
            titleClass: "u-ta-left",
            title: "Description",
            width: "20%",
          },
          {
            name: "resource",
            titleClass: "u-ta-left",
            title: "Resource Link",
            width: "20%",
          },
          {
            name: "date-created",
            titleClass: "u-ta-left",
            title: "Date Created",
            width: "20%",
          },
          {
            name: "category-actions",
            title: "Actions",
            titleClass: "u-ta-center u-hide-mobile",
            dataClass: "u-ta-center u-hide-mobile",
            width: "10%",
          },
        ],
      },
    };
  },

  computed: {
    ...mapState("Banner", ["pagination", "banners"]),
  },

  watch: {
    banners(newValue, oldValue) {
      if (newValue && newValue.length !== oldValue.length) {
        this.updateTable();
      }
    },
  },

  mounted() {
    this.$store.dispatch("Banner/list", { flat: true }).then((resp) => {
      this.loading = false;
    });
  },
  methods: {
    onRowClass(item, index) {
      return item.status && item.status === "active" ? "bg-active" : "";
    },
    updateTable() {
      this.$refs.bannerTable.refresh();
    },
    dataManager(sortOrder, pagination) {
      const returnObj = {
        ...this.pagination,
        data: this.banners,
      };

      return returnObj;
    },
    onPaginationData(paginationData) {
      this.$refs.pagination.setPaginationData(paginationData);
    },
    onChangePage(page) {
      const vm = this;
      const tableref = vm.$refs.bannerTable;
      let nextPage;
      this.loading = true;

      switch (page) {
        case "next":
          nextPage = ++this.$store.state.News.pagination.current_page;
          break;
        case "prev":
          nextPage = --this.$store.state.News.pagination.current_page;
          break;
        default:
          nextPage = page;
          break;
      }
      this.$store
        .dispatch("Banner/list", {
          includeWeb: false,
          page: nextPage,
          flat: true,
        })
        .then((resp) => {
          window.scroll(0, 0);
          tableref.changePage(nextPage);
          this.loading = false;
        });
    },
  },
};
</script>

<style lang="scss">
.bg-active {
  background: lighten($colour-nhs-light-green, 50%);
}
</style>
